<template>
  <div class="">
    <div class="head-title">线索池</div>
    <el-collapse style="margin-bottom: 2.0rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>
            1、企业在管理后台通过模板批量导入线索、分配线索，可以选择分配员工那些线索。
          </p>
          <p>
            2、员工个人线索根据后台设置参数，触发了规则或者员工手动将线索投入公海的线索将会在线索池内展示，在线索池内也可领取意向线索进行再次跟进。
          </p>
        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="mMain">
      <nav>
        <div class="navbar">
          <div class="narbar-l">
            <span class="shij">
              <el-button @click="(onSubmit = true), tianjia()" icon="el-icon-upload" type="primary">导入线索</el-button>
              <el-button type="primary" icon="el-icon-download">
                <a href="https://api.weijub.com/tmp/线索列表.xls" style="color: #fff">下载模板</a>
              </el-button>
              <el-button icon="el-icon-s-promotion" @click="fenpei" type="primary">分配</el-button>
            </span>
          </div>
          <div class="narbar-r">
            <span class="">
              <el-input clearable placeholder="请输入线索名称搜索" style="width: 27.0rem; "
                prefix-icon="el-icon-search" v-model="input2" @change="rune()">
              </el-input>
              <el-button slot="append" @click="rune()" type="primary">查询</el-button>
            </span>
          </div>
        </div>
      </nav>
      <el-table :data="tableData.data" border  style="width: 100%; margin-top: 2.0rem"
        @selection-change="handleSelectionChange" v-loading="loading">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="name" label="线索名称" style="width: 10%"></el-table-column>
        <el-table-column prop="remark_mobiles" label="电话" style="width: 10%"></el-table-column>
        <el-table-column prop="gender" label="性别" style="width: 10%">
          <template slot-scope="scope">
            <div v-if="scope.row.gender == 1">男</div>
            <div v-else-if="scope.row.gender == 2">女</div>
            <div v-else>{{ scope.row.gender }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="position" label="职位" style="width: 10%"></el-table-column>
        <el-table-column prop="corp_full_name" label="公司名称" style="width: 10%"></el-table-column>
        <el-table-column prop="detail_address" label="详细地址" style="width: 10%"></el-table-column>
        <el-table-column prop="up_date" label="成立日期" style="width: 10%"></el-table-column>
      </el-table>
      <div class="paging">
        <pagination :total="tableData.total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
          :page-sizes="[10, 20, 50, 100]" :auto-scroll="false" @pagination="handleCurrentChange" />
      </div>

      <el-dialog title="导入" center  :visible.sync="onSubmit" width="30%">
        <el-form ref="form" :model="form" label-width="8.0rem">
          <el-upload class="upload-demo" :action="
            `${baseURL}/home/uploads/uploads?usertoken=` +
            this.tooken.usertoken +
            '&account_id=' +
            this.tooken.account_id
          " :on-preview="handlePreview" :on-success="chenggong" :on-remove="handleRemove" :before-remove="beforeRemove"
            multiple :limit="1" accept="application/vnd.ms-excel" :on-exceed="handleExceed" :file-list="fileList">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传xls文件，且不超过500kb
            </div>
          </el-upload>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="(onSubmit = false), rel()">取 消</el-button>
          <el-button type="primary" @click="(onSubmit = false), numoo()">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="错误信息" center  :visible.sync="onSubmitss" width="30%">
        <!--<div class="abude">
          <div v-for="item in value4.data" :key="item">{{ item }}</div>
        </div>--->
        <div class="abude">
          <el-table id="educe-table" :cell-style="columnStyle" tooltip-effect="dark" style="width: 100%"
            :data="value4.data" border>
            <el-table-column prop="name" label="线索名">
            </el-table-column>
            <el-table-column prop="message" label="错误信息"></el-table-column>
            <el-table-column prop="mobiles" label="手机号"> </el-table-column>
          </el-table>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="(onSubmitss = false), rel()">取 消</el-button>
          <el-button type="primary" @click="(onSubmitss = false), rel()">确 定</el-button>
          <el-button type="primary" @click="exportExcel">导 出</el-button>
        </span>
      </el-dialog>
      <el-dialog title="编辑" center  :visible.sync="onSubmitn" width="30%">
        <el-form ref="form" :model="form" label-width="8.0rem">
          <el-form-item label="名称" prop="none">
            <el-input clearable v-model="bianjile">{{ bianjile }}</el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="onSubmitn = false">取 消</el-button>
          <el-button type="primary" @click="numoon()">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="选择分配员工" center  :visible.sync="onSubmitne" width="30%">
        <el-form ref="form" :model="form" label-width="8.0rem">
          <el-table :data="datanec" stripe v-infinite-scroll="loadd" style="
                    width: 100%;
                    height: 30.0rem;
                    overflow: hidden;
                    overflow-y: auto;
                  " v-loading="loading">
            <el-table-column prop="name" label="员工名称" style="width: 10%"></el-table-column>
            <el-table-column fixed="right" label="操作" style="width: 10%">
              <template slot-scope="scope">
                <el-button @click="(onSubmitne = false), yuangon(scope.row.userid)" type="text">选择</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="onSubmitne = false">取 消</el-button>
        </span>
      </el-dialog>
    </div>
    <right-people ref="dialog" :checkbox="checkbox" @handleSelect="handleSelect"></right-people>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import Pagination from "@/components/Pagination";
import rightPeople from '@/components/drawer/rightPeople';
import FileSaver from 'file-saver'
import * as XLSX from 'xlsx'
import RightPeople from '../../components/drawer/rightPeople.vue';
export default {
  inject: ["reload"],
  name: "monitoring",
  components: {
    Pagination,
    rightPeople
  },
  data() {
    return {
      url: "https://api.weijub.com/",
      title: {},
      tooken: "",
      tableData: {
        data: [],
        total: 0,
      },
      input2: "",
      onSubmit: false,
      onSubmitn: false,
      onSubmitne: false,
      tableData_a: [],
      multipleSelection: [],
      value1: true,
      form: {
        name: "",
        none: "",
        enterprisePhoto: "",
      },
      ele: "",
      yeshu: 1,
      bianjile: "",
      lock: true,
      code: "1",
      fileList: [],
      baseURL: this.axios.defaults.baseURL,
      loading: false,
      page: "1",
      pagen: "1",
      datanec: {},
      yuangongid: "",
      i: 0,
      nlist: "",
      jixu: 1,
      value4: [],
      onSubmitss: false,
      listQuery: {
        page: 1,
        limit: 20,
      },
      module: "",
      checkbox: false
    };
  },
  mounted() {
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.userTable();
    this.yuangong();
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
    },
    yuangon(vue) {
      let ids = [];
      for (const i of this.multipleSelection) {
        ids.push(i.id);
      }
      this.axios
        .post(
          "/crm/source/assignUser",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            userid: vue,
            ids: ids.toString(),
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.$message.error(res.data.msg);
          }
          this.userTable();
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
        })
        .catch(function (err) { });
    },
    handleSelectionChanges(val) {
      this.yuangongid = val;
    },
    yuangong() {
      this.pagen = 1;
      this.axios
        .post(
          "/crm/source/getCooperationUser",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            page: this.pagen,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.datanec = res.data.data;
        })
        .catch(function (err) { });
    },
    fenpei() {
      if (!this.multipleSelection.length) {
        this.$message({
          message: "请选择线索!",
        });
      } else {
        this.module = "getCooperationUser";
        this.$refs.dialog.open();
      }
    },
    handleSelect(val) {
      if (!val.name) {
        return;
      }
      this.$confirm(`您确定要分配给${val.name}吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.yuangon(val.userid);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    chenggong(response, file, fileList) {
      this.$message({
        message: response.msg,
        type: "success",
      });
      this.form.enterprisePhoto = file.response.data;

    },
    handleRemove(file, fileList) { },
    handlePreview(file) { },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    loadd() {
      this.pagen += 1;
      if (this.jixu == 1) {
        this.axios
          .post(
            "/crm/source/getCooperationUser",
            qs.stringify({
              usertoken: this.tooken.usertoken,
              account_id: this.tooken.account_id,
              phone: this.tooken.phone,
              page: this.pagen,
            }),
            { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            if (res.data.msg == "登录超时") {
              this.$router.push("/register");
            }
            this.jixu = res.data.code;
          })
          .catch(function (err) { });
      } else {
        return;
      }
    },
    //  页数
    handleCurrentChange() {
      this.axios
        .post(
          "/crm/source/leadesPool",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            page: this.listQuery.page,
            number_page: this.listQuery.limit,

          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData = res.data.data;
        })
        .catch(function (err) { });
    },
    userTable() {
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/source/leadesPool",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            page: this.page,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData = res.data.data;
        })
        .catch(function (err) { });
    },
    rune() {
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/source/leadesPool",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            name: this.input2,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData = res.data.data;
        })
        .catch(function (err) { });
    },
    tianjia() {
      this.yeshu = 1;
      this.axios
        .post(
          "/home/sessionUser/ifRemoveUserTwo",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_a = res.data.data;
        })
        .catch(function (err) { });
    },

    handleSelectionChange(val) {
      this.yeshu = 1;
      this.multipleSelection = val;
    },
    bianji(e, o) {
      this.yeshu = 1;
      this.ele = e;
      this.bianjile = o;
    },
    // 修改
    numoon() {
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/CustomerLevel/editCustomerLevel",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            name: this.bianjile,
            id: this.ele,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmitn = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.onSubmitn = true;
            this.$message.error(res.data.msg);
          }
          this.userTable();
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_a = res.data.data;
        })
        .catch(function (err) { });
    },
    // 添加
    numoo() {
      this.loading = true;
      this.yeshu = 1;
      this.aaa();
    },
    //刷新
    rel() {
      this.reload();
    },
    aaa() {
      if (this.form.enterprisePhoto == "") {
        this.$message.error("请选择导入文件");
        this.loading = false;
        return;
      }
      this.axios
        .post(
          "/crm/source/importData",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            file_path: this.form.enterprisePhoto,
            page: this.page,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {

          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          if (res.data.code == 1) {
            this.page = this.page * 1 + 1;
            this.aaa();
          } else if (res.data.code == 2) {
            this.loading = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });

            this.userTable();
            return;
          } else if (res.data.code == 3) {
            this.loading = false;
            this.onSubmitss = true;
            this.value4 = res.data;
            this.userTable();
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) { });
      this.fileList = []
    },
    columnStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 0) {
        return 'color:	red;'
      }
    },
    exportExcel() {
      // 1.生成Excel工作簿对象
      var wb = XLSX.utils.table_to_book(document.querySelector('#educe-table'))
      var wbout = XLSX.write(wb, {
        bookType: 'xlsx',
        book: true,
        type: 'array'
      })
      try {
        FileSaver.saveAs(
          // Blob: 对象表示一个不可变 原始数据的类文件对象,不一定是JS原生格式的数据。
          // File: 基于Blob，继承了blob的功能并将其扩展使其支持用户系统上的文件。
          new Blob([wbout], { type: 'appliction/octet-stream' }),
          // 设置导出的文件名称可随意
          '线索池错误信息.xls'
        )
      } catch (e) {
        if (typeof console != 'undefined') console.log(e, wbout)
      }
      // 返回一个新创建的Blob对象，其内容由参数中给定的数组串联组成。
      return wbout
    }
  },
};
</script>
<style scoped>
.home {
  width: 100%;
  height: 100%;
}

.body_html {
  width: 100%;
  height: 100%;
}

.wei_body {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  -webkit-box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
  box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
  padding: 2.3rem 3.1rem;
  overflow: hidden;
  overflow-y: auto;
}

.abude {
  color: rgb(238, 39, 39);
  font-size: 1.8rem;
  font-weight: 500;
  height: 20.0rem;
  overflow: hidden;
  overflow-y: auto;
}

.abude>div {
  padding: .5rem;
}

.hello {
  width: 100%;
  height: 100%;
  padding: 2.0rem;
  overflow: hidden;
  overflow-y: auto;
}

nav {
  width: 100%;
}

.shij {
  display: inline-block;
  margin-right: 2.4rem;
}

</style>
<style >
.el-table .cell {
  visibility: visible !important;
}

.navbar {
  display: flex;
  justify-content: space-between;
}
</style>
